import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

const NotFound = () => (
    <main className="min-h-screen flex flex-col items-center justify-center text-center px-5">
        <Seo title="Page Not Found | BSK Jewellers" siteName="BSK Jewellers" />
        <p className="font-serif italic text-[7rem] leading-none text-gold/15 select-none">404</p>
        <h1 className="font-serif text-3xl sm:text-4xl -mt-8">This page has been <span className="italic gold-text">moved or set aside</span></h1>
        <Link to="/" data-testid="notfound-home-btn" className="mt-10 bg-gold text-obsidian text-[11px] tracking-[0.25em] uppercase px-9 py-4 hover:bg-gold-bright transition-colors">
            Return Home
        </Link>
    </main>
);

export default NotFound;
